import React from 'react';
import './NotificationBadge.css';

const NotificationBadge = ({ count, className = '' }) => {
  if (count <= 0) return null;

  return (
    <div className={`notification-badge ${className}`}>
      {count > 99 ? '99+' : count}
    </div>
  );
};

export default NotificationBadge;
